import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <div className="text-center py-16">
      <p className="text-sm uppercase tracking-wide text-amp-500 mb-2">404</p>
      <h1 className="text-2xl font-semibold text-amp-900 mb-2">Page not found</h1>
      <p className="text-amp-700 mb-4">That page does not exist in Cockpit.</p>
      <Link to="/" className="text-amp-900 underline">
        Back to home
      </Link>
    </div>
  );
}
